<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
import { urlRegex } from '@/helper'
import { isEmpty } from 'lodash'

export default {
  name: 'LinkPreview',
  props: {
    preview: {
      type: Object,
    },
    isPending: {
      type: Boolean,
    },
    link: {
      type: String,
    },
    title: String,
    pendingTitle: String,
    label: String,
  },
  data() {
    return {
      delayTimer: null,
      tempLink: '',
      urlRegex,
    }
  },
  computed: {
    previewTitle() {
      return this.preview.title || this.preview.url
    },
    isNotEmpty() {
      return !isEmpty(this.preview)
    },
  },
  watch: {
    link() {
      this.tempLink = this.link
    },
  },
  created() {
    if (!this.tempLink && this.preview?.url) {
      this.tempLink = this.preview.url
    }
  },
  methods: {
    getContentClass() {
      if (this.preview) {
        return this.preview.video_url || this.preview.image ? 'col-sm-7' : ''
      }
    },
    removeMedia() {
      this.$emit('onRemoveMedia')
    },
    onInput(value) {
      this.$emit('onInput')
      this.$emit('onUpdateValue', value)
      if (value.length < 10) return
      clearTimeout(this.delayTimer)
      this.delayTimer = setTimeout(() => {
        if (!this.urlRegex.test(value)) return
        this.$emit('onValidUrl', value)
      }, 500)
    },
  },
}
</script>
